module.exports = {"TXTWCL_Unlock":{"id":"TXTWCL_Unlock","defaultMessage":"Ξεκλείδωμα","flags":["TRACK"],"track":"Unlock"}}